import Backbone from 'backbone';
import tmpl from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/message.pug';

export class MessageView extends Backbone.View {
  initialize({
    title,
    content,
  }) {
    this.title = title;
    this.content = content;
  }

  render() {
    this.$el.html(tmpl({
      title: this.title,
      content: this.content,
    }));
    return this;
  }
}
